import { OtherCostWithCalculations } from "~/helpers/otherCosts"

import { RateTypeSelection } from "~/GLOBALVARS"

import { BudgetedPhaseAndRole, BudgetedRole, ProjectRate } from "./types"

export type ProjectBudgetFormData = {
  // Project Configuration
  projectId: number
  pricingModel: "fp" | "tm" | "nb" // Fixed Price, Time & Materials, Non-Billable
  budgetMethod: "ROLE" | "PHASE" | "PHASE_AND_ROLE"
  rateType: RateTypeSelection["value"]
  rateCardId: number

  // Budget Fields
  totalBudget: number | null
  expensesBudget: number | null
  noPhaseBudget: number

  // Role Management
  roles: BudgetedRole[]
  deletedRoleIds: number[]

  // Rate Management
  projectRates: ProjectRate[]
  deletedProjectRateIds: number[]

  // Expense Management
  otherExpenses: OtherCostWithCalculations[]

  // Phase Management (when budgetMethod === "PHASE")
  phaseBudgets: Array<{
    phaseId: number
    revenueBudget: number
  }>

  // Phase and Role Management (when budgetMethod === "PHASE_AND_ROLE")
  phaseAndRoleBudgets: BudgetedPhaseAndRole[]
}

// Form validation schema
export const projectBudgetValidationRules = {
  totalBudget: {
    validate: (value: number | null) => {
      if (value === null || value === undefined) return true
      return value >= 0 || "Budget cannot be negative"
    },
  },
  otherExpenses: {
    validate: (expenses: OtherCostWithCalculations[]) => {
      // Validate that expenses with cost/charge have names
      return (
        expenses.every(
          (expense) =>
            expense.name.trim() || (expense.cost === 0 && expense.charge === 0),
        ) || "Expenses with cost or charge must have a name"
      )
    },
  },
  roles: {
    validate: (roles: BudgetedRole[], formValues: ProjectBudgetFormData) => {
      // Ensure at least one role if not non-billable
      return (
        roles.length > 0 ||
        formValues.pricingModel === "nb" ||
        "At least one role required"
      )
    },
  },
}
